// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__BdzF1","content":"styles_content__gzt+0","header":"styles_header__MMciL","attachment_label":"styles_attachment_label__bbAVP"};